import * as JsSearch from "js-search";
import { useEffect } from "react";

const searchIndex = new JsSearch.Search("id");

function useSearchIndex(data) {
  useEffect(
    function () {
      searchIndex.addIndex("plainText");
      searchIndex.addIndex("tags");
      searchIndex.addDocuments(data);
    },
    [data]
  );

  function searchAction(text = "") {
    return searchIndex.search(text);
  }

  return { searchAction, results: searchIndex };
}

export default useSearchIndex;
